import React, { useState, useEffect } from 'react'
import Layout from '../../components/Layout'
import Toast from '../../utils/toast'
import { isOwnerRole } from '../../utils/roles'
import { API_BASE_URL } from '../../config/api'
import '../../styles/change-status-modal.css'

function CasinoConfig() {
    const [tables, setTables] = useState([])
    const [loading, setLoading] = useState(true)

    const fetchTables = async () => {
        setLoading(true)
        try {
            const activeRole = localStorage.getItem('activeRole')
            const token = isOwnerRole(activeRole)
                ? localStorage.getItem('ownerToken')
                : activeRole === 'staff'
                    ? localStorage.getItem('staffToken')
                    : localStorage.getItem('token')

            const response = await fetch(`${API_BASE_URL}/casino/casino/table-config`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            const data = await response.json()
            if (data.success && data.data) {
                setTables(data.data)
            } else {
                Toast.fire({ icon: 'error', title: 'Failed to fetch table config' })
            }
        } catch (err) {
            console.error(err)
            Toast.fire({ icon: 'error', title: 'Error fetching table config' })
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchTables()
    }, [])

    const handleToggle = async (type, currentStatus) => {
        const activeRole = localStorage.getItem('activeRole')
        const token = isOwnerRole(activeRole)
            ? localStorage.getItem('ownerToken')
            : activeRole === 'staff'
                ? localStorage.getItem('staffToken')
                : localStorage.getItem('token')

        const newStatus = !currentStatus

        // Optimistic update
        setTables(prev => prev.map(t => t.type === type ? { ...t, status: newStatus } : t))

        try {
            const response = await fetch(`${API_BASE_URL}/casino/casino/table-lock`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ type: type, status: newStatus })
            })

            const data = await response.json()
            if (!response.ok || (data && data.success === false)) {
                // Revert on failure
                setTables(prev => prev.map(t => t.type === type ? { ...t, status: currentStatus } : t))
                Toast.fire({ icon: 'error', title: data.message || 'Failed to update table status' })
            } else {
                Toast.fire({ icon: 'success', title: 'Table status updated successfully' })
            }
        } catch (err) {
            console.error(err)
            setTables(prev => prev.map(t => t.type === type ? { ...t, status: currentStatus } : t))
            Toast.fire({ icon: 'error', title: 'Error updating table status' })
        }
    }

    return (
        <Layout title="Casino Config - Diamond Admin">
            <div className="listing-grid">
                <div className="account-list">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0 font-size-18">Casino Config</h4>
                            </div>
                        </div>
                    </div>

                    <div className="account-list">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="table-responsive mb-0">
                                        <div className="table no-footer list-clients table-responsive-sm">
                                            <table role="table" className="table b-table table-striped table-bordered">
                                                <thead role="rowgroup">
                                                    <tr role="row">
                                                        <th role="columnheader" scope="col" className="position-relative text-center" style={{ width: '10%' }}>
                                                            <div>ID</div>
                                                        </th>
                                                        <th role="columnheader" scope="col" className="position-relative text-left">
                                                            <div>Table Name (Type)</div>
                                                        </th>
                                                        <th role="columnheader" scope="col" className="position-relative text-center" style={{ width: '20%' }}>
                                                            <div>Status</div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody role="rowgroup">
                                                    {loading ? (
                                                        <tr role="row">
                                                            <td colSpan="3" className="text-center">Loading...</td>
                                                        </tr>
                                                    ) : tables.length === 0 ? (
                                                        <tr role="row">
                                                            <td colSpan="3" className="text-center">No tables found</td>
                                                        </tr>
                                                    ) : (
                                                        tables.map(table => (
                                                            <tr role="row" key={table.id}>
                                                                <td aria-colindex="1" role="cell" className="text-center font-weight-bold">
                                                                    {table.id}
                                                                </td>
                                                                <td aria-colindex="2" role="cell" className="text-left font-weight-bold text-uppercase">
                                                                    {table.type}
                                                                </td>
                                                                <td aria-colindex="3" role="cell" className="text-center">
                                                                    <label
                                                                        className={`vue-js-switch ${table.status ? 'toggled' : ''} mb-0`}
                                                                        onClick={(e) => { e.preventDefault(); handleToggle(table.type, table.status); }}
                                                                        title={`Click to turn ${table.status ? 'Off' : 'On'}`}
                                                                    >
                                                                        <input type="checkbox" className="v-switch-input" checked={table.status} readOnly />
                                                                        <div className="v-switch-core">
                                                                            <div className="v-switch-button"></div>
                                                                        </div>
                                                                        <span className={`v-switch-label ${table.status ? 'v-left' : 'v-right'}`}>
                                                                            {table.status ? 'on' : 'off'}
                                                                        </span>
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default CasinoConfig
